<template>
  <div class="home">
    <div class="relative">
      <div class="input-wrapper">
        <el-autocomplete class="input-large__oval" v-model="state" :fetch-suggestions="querySearch" placeholder="请输入内容"
          :trigger-on-focus="false" clearable @select="handleSelect" />
        <el-button size="80" round @click="handleSearch">查询</el-button>
      </div>
      <div class="charts">
        <div class="box" v-for="(item, index) in appletsAll" :key="index">
          <div class="mar20">
            <h3 class="hd">
              <img class="logo" src="../../assets/img/winner_logo.png" alt="" />
              <span class="title">{{ item.app_name }}</span>
              <router-link v-permission:details="$route.meta.permission" class="link" :to="{
                name: 'subHome',
                query: {
                  applet_id: item.applet_id,
                  merchant_id: item.merchant_id,
                  title: item.app_name,
                  index: index
                }
              }">
                MORE
                <i class="el-icon-arrow-right"></i>
              </router-link>
            </h3>
            <div class="bd">
              <div class="chart">
                <h3 class="char-title">订单金额</h3>
                <chart-line v-bind="$attrs" :chartLineData="item.chartLineData" :legendVisible="false" :loading="false"
                  :dataEmpty="item.chartLineData.rows.length === 0" :chartLineSettings="chartLineSettings"
                  :colors="['#ff3649', '#34313a']" height="14rem" :chartOptions="chartOptions" />
                <div class="real-data real-data__line">
                  <span class="category">跨境</span>
                  <span class="price mar1">{{ item.cross_border_total }}</span>
                  <span class="category black">完税</span>
                  <span class="price">{{ item.duty_paid_total }}</span>
                </div>
              </div>
              <div class="chart">
                <h3 class="char-title">会员比例</h3>
                <chart-ring v-bind="$attrs" :chartRingData="item.chartRingData" :legendVisible="false" :loading="false"
                  :dataEmpty="item.chartRingData.rows.length === 0" :chartRingSettings="chartRingSettings"
                  :chartOptions="chartRingOptions" height="14rem" :colors="['#ff3649', '#34313a', '#d4b68a']" />
                <div class="real-data real-data__ring">
                  <div class="vip-all__number">
                    <span class="num">{{ item.membership_total }}</span>
                    <span class="block">总会员数</span>
                  </div>
                  <div class="vip-number">
                    <p class="item" v-for="(i, idx) in item.chartRingData.rows" :key="idx">
                      <span class="sex">{{ i.gender }}:</span>
                      <span class="num ellipses"> {{ i.number }}</span>
                      <span class="percentage">
                        {{ _percentage(i, item) }}%
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="chart">
                <h3 class="char-title" style="top: 0.8rem">热销商品</h3>
                <char-bar v-bind="$attrs" :chartBarData="item.chartBarData" :loading="false" :legendVisible="false"
                  :dataEmpty="item.chartBarData.rows.length === 0" :chartBarSettings="chartBarSettings"
                  :chartOptions="chartBarOptions" height="14rem" :colors="['#ff3649', '#d4b68a']" style="left: -0.6rem" />
              </div>
              <div class="chart">
                <h3 class="char-title" style="top: 0.8rem">访问数据</h3>
                <chart-line v-bind="$attrs" :chartLineData="item.chartPvData" :loading="false"
                  :dataEmpty="item.chartPvData.rows.length === 0" :legendVisible="false"
                  :chartLineSettings="chartPvSettings" height="14rem" :colors="['#ff3649', '#d4b68a']"
                  :chartOptions="chartOptions" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Pagination style="bottom: 0" v-if="pagination.recordTotal > 1" :currentPage="pagination.currentPage"
        :totalPage="pagination.pageTotal" :totalRecord="pagination.recordTotal" :pageSize="[10, 20, 30]"
        @handleNextPage="nextPage" @handlePrevPage="prevPage" @handleJumpPage="jumpPage"
        @handleChangePageSize="changePageSize" />
    </div>
  </div>
</template>
<script>
import ChartLine from 'components/Chart/Line/'
import ChartRing from 'components/Chart/Ring/'
import CharBar from 'components/Chart/Bar/'
import resize from 'mixins/chartsResize/'
import pagination from 'mixins/pagination'
import filterDownData from 'mixins/filterDownData'
import { mapMutations } from 'vuex'

export default {
  name: 'home',
  mixins: [resize, pagination, filterDownData],
  data() {
    this.curpage = 1
    this.type = 'pagination'
    this.sendOrderNumber = 0;
    this.chartOptions = {
      xAxis: {
        axisLabel: {
          color: 'transparent'
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: '#e1e1e1'
          }
        },
        splitLine: { show: false }
      },
      yAxis: {
        axisLabel: {
          color: 'transparent'
        },
        axisLine: {
          show: true,
          onZero: true,
          onZeroAxisIndex: 1,
          lineStyle: {
            color: '#e1e1e1'
          }
        },
        position: 'left',
        splitLine: { show: false }
      },
      series: {
        type: 'line',
        smooth: true,
        barWidth: 10
      }
    }
    this.chartBarOptions = {
      yAxis: {
        axisLabel: {
          formatter: function (value, index) {
            return value
              .split(' ')
              .slice(-1)[0]
              .slice(0, 4)
          }
        }
      }
    }
    this.chartLineSettings = {}
    this.chartRingSettings = {
      radius: [40, 50],
      offsetY: 100
    }
    this.chartRingOptions = {}
    this.chartBarSettings = {
      xAxisType: ['KMB'],
      digit: 1,
      metrics: ['销售量'],
      dataOrder: {
        label: '销售量',
        order: 'desc'
      }
    }
    this.chartPvSettings = {
      xAxisType: 'time',
      area: true,
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              // '#c23531','#2f4554', '#61a0a8',
              offset: 0,
              color: '#A9C9FF' // 0% 处的颜色
            },
            {
              offset: 1,
              color: '#FFBBEC ' // 100% 处的颜色
            }
          ],
          global: false // 缺省为 false
        }
      }
    }
    this.keyMap = {
      order_data: {
        name: 'chartLineData',
        subName: 'rows',
        date_time: '日期',
        cross_border_amount: '跨境',
        duty_pay_amount: '完税',
        adds: [
          {
            name: 'columns',
            value: ['日期', '跨境', '完税']
          }
        ]
      },
      goods_list: {
        name: 'chartBarData',
        goods_name: '商品名称',
        sales_volumes: '销售量',
        subName: 'rows',
        adds: [
          {
            name: 'columns',
            value: ['商品名称', '销售量']
          }
        ]
      },
      member_list: {
        name: 'chartRingData',
        subName: 'rows',
        member_gender: 'gender',
        member_number: 'number',
        adds: [
          {
            name: 'columns',
            value: ['gender', 'number']
          }
        ]
      },
      visit_data: {
        name: 'chartPvData',
        subName: 'rows',
        date_time: '日期',
        visit_number: '访问用户',
        order_quantity: '下单用户',
        adds: [
          {
            name: 'columns',
            value: ['日期', '访问用户', '下单用户']
          }
        ]
      }
    }
    return {
      state: '',
      appletsAll: [],
      pagination: {}
    }
  },
  components: {
    ChartLine,
    ChartRing,
    CharBar
  },

  created() {
    this._getData({ curpage: this.curpage })
  },


    updated() {
      if (this.sendOrderNumber > 0) {
        this.$notify({
          title: '通知',
          dangerouslyUseHTMLString: true,
          message: '有' + '<span style="color:red">' + this.sendOrderNumber + '</span>' + '笔订单待发货，请及时发货!',
          position: 'top-right',
          type: 'warning',
          duration: 0,
          offset: 70,
          showClose: true
        });
      }
  },

  methods: {
    ...mapMutations({
      add: 'chartRingData/CHANGE_CHARTRINGDATA'
    }),
    /**
     * 请求数据并设置数据
     * @private
     */
    _getData(data) {
      return this.api.getHomeData(data).then(res => {
        const data = res.statistics_list
        if (Array.isArray(data)) {
          data.forEach(v => {
            this.utils._modifyObjKey(v, this.keyMap)
          })
          this.appletsAll = data
          this._setStoreRingData(this.appletsAll)
          this.pagination.pageTotal = res.page_count
          this.pagination.recordTotal = res.total_number
          this.sendOrderNumber = res.send_order_number
        }
      })
    },
    /**
     * 计算百分比
     * @param i
     * @param item
     */
    _percentage(i, item) {
      const num = ((i.number / item.membership_total) * 100).toFixed(2)
      return isNaN(num) ? 0 : num
    },
    /**
     * 将饼图数据保存在store
     * @param data
     */
    _setStoreRingData(data) {
      let newData = []
      data.forEach(v => {
        newData.push(v.chartRingData)
      })
      this.add(newData)
    },

    /**
     * 查询
     */
    handleSearch() {
      if (this.state !== '') {
        this._getData({ app_name: this.state.replace(/\+/, '') })
      } else {
        this.$notify({
          title: '请输入正确的小程序名称~！',
          type: 'error'
        })
      }
    },
    querySearch(queryString, cb) {
      const restaurants = this.filterDownData('appletsList')
      const results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(
        results.map(v => {
          return { value: v.label }
        })
      )
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.label.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    handleSelect(item) {
      console.log(item)
    },
    /**
     * 调用父组件请求数据函数
     * @param vm
     * @param newValue
     * @param type
     * @param size
     * @private
     */
    _parentComponentRequest(vm, newValue, type, size) {
      this._getData({ curpage: newValue, pageSize: size })
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  @include maxScreenWidth(768) {
    overflow: hidden;
  }
}

.input-wrapper {
  margin: -1.3rem -1.3rem 0;
  background-color: #fff;
  padding: 1rem 0;
  text-align: center;
  justify-content: center;
}

.charts {
  padding: 1.3rem 0;
  display: flex;
  flex-wrap: wrap;
  margin-right: -1.3rem;
}

.category {
  display: inline-block;
  width: 2.5rem;
  height: 1.3rem;
  line-height: 1.4rem;
  background-color: colors('bg-sub');
  border-radius: 0.6rem;
  color: #fff;
  text-align: center;
  margin-right: 0.3rem;

  &.black {
    background-color: colors('bg-main');
  }
}

.price {
  &.mar1 {
    margin-right: 1rem;
  }
}

.box {
  width: 33.33%;
  height: 35rem;
  margin-bottom: 1.3rem;

  @include maxScreenWidth(1900) {
    width: 50%;
  }

  @include maxScreenWidth(1280) {
    width: 100%;
  }

  .chart {
    &:nth-child(1) {
      border-right: 1px solid colors('bor-main');
      border-bottom: 1px solid colors('bor-main');
    }

    &:nth-child(2) {
      border-bottom: 1px solid colors('bor-main');
    }

    &:nth-child(3) {
      border-right: 1px solid colors('bor-main');
    }
  }
}

.hd {
  display: flex;
  align-items: center;
  position: relative;
  padding-bottom: 1.6rem;
  border-bottom: 1px solid colors('bor-main');
}

.mar20 {
  height: 100%;
  margin-right: 1.3rem;
  background-color: #fff;
  padding: 1.4rem 1rem;
}

.bd {
  display: flex;
  flex-wrap: wrap;
  padding-top: 0.8rem;
}

.chart {
  width: 50%;
  position: relative;
}

.tips {
  position: absolute;
  top: calc(5.2rem - 20px);
  left: 50%;
  transform: translate(-50%, 0);
  width: 1.8rem;
}

.char-title {
  position: absolute;
  /*top: 1.3rem;*/
  left: 50%;
  transform: translateX(-50%);
}

.real-data {
  position: absolute;
  width: 100%;
  z-index: 100;
}

.real-data__line {
  bottom: 1.2rem;
  text-align: center;
}

.real-data__ring {
  bottom: 0;
}

.vip-all__number {
  float: left;
  text-align: center;
  margin-left: 2.3rem;

  .num {
    display: block;
    font-size: 1.1rem;
    font-weight: bold;
  }

  .block {
    display: block;
    width: 4.3rem;
    height: 1.3rem;
    background-color: #eeeeee;
    border-radius: 0.7rem;
    text-align: center;
  }
}

.vip-number {
  float: right;
  position: relative;
  bottom: 0.9rem;

  .item {
    position: relative;
    margin-bottom: 0.1rem;

    .num {
      padding: 0 0.12rem;
    }

    &:before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: -1rem;
      margin: auto;
      width: 0.4rem;
      height: 0.4rem;
      border-radius: 50%;
    }

    &:nth-child(1) {
      &:before {
        background-color: colors('bg-sub');
      }
    }

    &:nth-child(2) {
      &:before {
        background-color: colors('bg-main');
      }
    }

    &:nth-child(3) {
      &:before {
        background-color: #d4b68a;
      }
    }
  }
}

.logo {
  width: 2.5rem;
  height: 2.5rem;
}

.title {
  font-size: 1.1rem;
  padding-left: 0.8rem;
}

.link {
  position: absolute;
  right: 0;
  font-size: 1rem;
  color: #010101;

  .el-icon-arrow-right {
    text-align: center;
    display: inline-block;
    width: 1.3rem;
    height: 1.3rem;
    margin-left: 0.3rem;
    line-height: 1.3rem;
    border-radius: 50%;
    background-color: colors('bg-main');

    &:before {
      color: #fff;
    }
  }
}

.el-button--80 {
  width: 5rem;
  height: 2.9rem;
  border-radius: 1.4rem !important;
}
</style>
